'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    height: ', ';\n    width: 100%;\n'], ['\n    height: ', ';\n    width: 100%;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _script = require('../../hocs/script');

var _script2 = _interopRequireDefault(_script);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StreetviewContainer = _styledComponents2.default.div(_templateObject, function (_ref) {
    var isMobile = _ref.isMobile;
    return isMobile ? '250px' : '350px';
});

var Streetview = function (_React$Component) {
    _inherits(Streetview, _React$Component);

    function Streetview(props) {
        _classCallCheck(this, Streetview);

        var _this = _possibleConstructorReturn(this, (Streetview.__proto__ || Object.getPrototypeOf(Streetview)).call(this, props));

        _this.handleScriptLoad = function () {
            if (_this.props.address && _this.props.address.location && _this.props.address.location.latitude && _this.props.address.location.longitude) {
                var options = {
                    position: {
                        lat: parseFloat(_this.props.address.location.latitude),
                        lng: parseFloat(_this.props.address.location.longitude)
                    },
                    linksControl: false,
                    panControl: false,
                    enableCloseButton: false,
                    clickToGo: false,
                    motionTracking: false,
                    zoomControl: false,
                    addressControl: false,
                    fullscreenControl: false
                };
                /*global google*/
                _this.streetview = new google.maps.StreetViewPanorama(document.getElementById('StreetView'), options);
                _this.setState({ loaded: true });
            }
        };

        _this.state = {
            address: '',
            query: '',
            loaded: false
        };
        return _this;
    }

    _createClass(Streetview, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.state.loaded) {
                this.handleScriptLoad();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!this.state.loaded) {
                this.handleScriptLoad();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(StreetviewContainer, { id: 'StreetView', isMobile: this.props.mobile });
        }
    }]);

    return Streetview;
}(_react2.default.Component);

Streetview.contextTypes = {
    screen: _propTypes2.default.object
};

var WrappedStreetview = (0, _script2.default)(Streetview, 'gMaps', 'https://maps.googleapis.com/maps/api/js?libraries=places&key=@&gMaps&@');

exports.default = WrappedStreetview;